<template>
	<div v-bind:class="['modal-box', {'modal-box--error' : error}]" v-if="visible">
		<div class="modal-content">
			<header>
				<div class="modal-headers">
					<div class="modal-header">{{ title }}</div>
				</div>
			</header>
			<main>
				<p>{{ message }}</p>
				<div class="button-wrapper">
					<button v-if="buttons == 2" class="btn btn-round" @click="actionCancel">{{ buttonsLabels.cancel }}</button>
					<button class="btn btn-round btn-primary" @click="actionOK">{{ buttonsLabels.ok }}</button>
				</div>
			</main>
		</div>
	</div>
</template>

<script>

import Modal from './../../plugins/AppModal';

export default {
	data() {
		return {
			visible: false,
			error: false,
			buttons: 1,
			buttonsLabels: {
				ok: this.$t(`base.modal.ok`),
				cancel: this.$t(`base.modal.cancel`)
			},
			title: '',
			message: '',
			onOK: {},
			onCancel: {}
		}
	},
	methods: {
		actionCancel(callback = true) {
			this.visible = false
			if(callback && typeof this.onCancel === 'function') {
				this.onCancel()
			}
		},
		actionOK() {
			if(typeof this.onOK === 'function') {
				this.onOK()
			}
			this.actionCancel(false)
		},
		show(params) {
			this.visible = true
			this.error = params.error  || false
			this.buttons = params.buttons || 1
			params.buttonsLabels = params.buttonsLabels || {}
			this.buttonsLabels = {
				ok: (params.buttonsLabels || {}).ok || this.$t(`base.modal.ok`),
				cancel: (params.buttonsLabels || {}).cancel || this.$t(`base.modal.cancel`)
			}
			this.onOK = params.onOK || {}
			this.onCancel = params.onCancel || {}

			this.title = params.title || ''
			this.message = params.message || ''
		}
	},
	beforeMount() {
		Modal.EventBus.$on('show', (params) => {
			this.show(params)
		})
	}
}
</script>

<style scoped>
.modal-box > .modal-content {
	max-width: 500px;
}
.modal-box > .modal-content > header {
	padding: 0 20px;
	color: white;
	background: var(--main-color);
}

.modal-box > .modal-content > main {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.modal-box > .modal-content > main p:first-child {
	margin-top: 0;
}

.modal-box > .modal-content > main p {
	text-align: center;
}

.modal-box.modal-box--error > .modal-content > header {
	color: white;
	background: #FF5722;
}

.modal-box.modal-box--error > .modal-content > main {
	background: #FBE9E7;
}

.modal-box.modal-box--error > .modal-content > main .btn {
    color: #ff5622;
    background-color: #fff;
    border: 1px solid #ff5622;
}
.modal-box.modal-box--error > .modal-content > main .btn.btn-primary {
    color: white;
    background-color: #ff5622;
    border: 1px solid #ff5622;
}

.button-wrapper {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
}

.button-wrapper > .btn {
	margin: 5px 10px;
}

@media only screen and (max-width: 1025px)
{
	.modal-box > .modal-content {
		width: auto;
		height: auto;
		border-radius: var(--border-radius);
		margin: 10px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/alerts/AppModal.vue